<template>
  <div class="uccn-box content">
    <!-- 遮罩层 -->
    <Shade ref='shade'></Shade>
    <!-- 加载动画层 -->
    <Loading ref='myLoading'></Loading>
    <!-- 手机导航 -->
    <MobilNav ref='mobilNav'></MobilNav>
    <!-- 导航栏 -->
    <NavBar ref='myNav' id="topnavbar"></NavBar>
    <!-- 主要内容 -->
    <div class="mainView" v-if='localhost'>
      <!-- banner部分 -->
      <Banner id='banner' ref='banner' class="white"></Banner>
      <!-- 第一屏 -->
      <Introduce :textData='textData' :companyData='companyData' id='inter' class="black"></Introduce>
      <!-- 第二屏 -->
      <Serve class="white"></Serve>
      <!-- 第三屏 -->
      <OurServe :serveData='serveData' :swiperOptions='swiperOptions' :scrollbar='scrollbar' class="white"></OurServe>
      <!-- 第四屏 -->
      <Marketing :marketingData='marketingData' class="black"></Marketing>
      <!-- 第五屏 -->
      <Project class="black"></Project>
      <!-- 第六屏 -->
      <PhotoWall class="white"></PhotoWall>
    </div>
    <!-- 子页面内容 -->
    <div class="childView" v-else>
      <router-view ref='routersv' />
    </div>
    <Footer></Footer>
    <!-- <el-backtop :visibility-height='400'></el-backtop> -->
  </div>
</template>

<script>
  import Shade from '@/components/base/shade'//引入遮罩层  
  import Loading from '@/components/base/loading'//引入载入动效
  import MobilNav from '@/components/base/mobilnav'//引入手机导航
  import NavBar from '@/components/base/navbar'//引入头部导航
  import Banner from '@/components/main/home/banner'//引入bannner
  import Introduce from '@/components/main/home/introduce'//引入公司介绍
  import Serve from '@/components/main/home/serve'//引入服务介绍
  import OurServe from '@/components/main/home/ourserve'//引入我们的服务
  import Marketing from '@/components/main/home/marketing'//引入数字化营销服务
  import Project from '@/components/main/home/project'//引入案例集合
  import PhotoWall from '@/components/main/home/photowall'//引入照片墙
  import Footer from '@/components/base/footer'//引入底部导航
  export default {
    name: 'Uccn',
    data() {
      return {
        localhost: true,//是否不显示子页面
        transfromData: 0,//



        ElementArry: [],//改变logo的数组



        textData: ['ENCOURAGE POSITIVE FEEDBACK SHARE', 'INNOVATION CULTIVATE INDUSTRY PROFESSIONAL'],
        companyData: {
          title: 'Why Choose Us?',
          caption: '把握最佳引流渠道 打造量身企业内容',
          chinese: ['<p class="text-center">蓝鲸是一家运用数字化营销技术，帮助外贸企业在海外市场树立品牌的公司。</p><p class="text-center">我们认为中国制造业从来都不缺乏匠人精神的制造商，但是缺乏建立品牌和形象的想法和方法。所以我们致力于为客户提供一整套完整的海外数字化媒体营销方案。帮助客户完成营销过程的全自动化管理。</p>'],
          english: '<p>Provide Google, social media, email marketing and other omni-channel applications, as well as enterprise training solutions and other full value chain</p><p>Provide Google, social media, email marketing and other omni-channel applications, as well as enterprise training solutions and other full value c</p>'
        },
        serveData: {//第三屏的数据
          caption: '海外数字营销解决方案',
          title: '我们有超过七年实战经验的运营团队，海归背景，精通外贸B2B，从策略制定到实施落地提供有力的运营保障。',
          baseurl: '/program',
          swiperData: [
            {
              // imgurl: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/home/banner1.jpg',
              imgurl: 'https://lanjingshuziguanwang-public.oss-accelerate.aliyuncs.com/IMG/case/1.gif ',
              caption: '数字广告服务',
              title: '<p>拥有Google广告与Facebook广告两大投放业务，基于强大的技术，实战经验服务能力，为客户提供满意的广告投放服务</p>',
              url: '/program/google'
            },
            {
              imgurl: 'https://lanjingshuziguanwang-public.oss-accelerate.aliyuncs.com/IMG/case/2.gif',
              caption: '社交媒体推广服务',
              title: '<p>透过搜索引擎规则来调整网站内容配置、并提供站内页面优化，站外外链制作，产品关键词布局等服务，提高网站在搜索引擎中排名。</p>',
              url: '/program/social'
            },
            {
              imgurl: 'https://lanjingshuziguanwang-public.oss-accelerate.aliyuncs.com/IMG/case/3.gif',
              caption: '邮件营销服务',
              title: '<p>通过专业、定制化的邮件营销，运用金字塔投放思维，帮助外贸企业激活老客，开发优质潜客。同时提供完善的线下培训咨询服务。</p>',
              url: '/program/email'
            },
            {
              imgurl: 'https://lanjingshuziguanwang-public.oss-accelerate.aliyuncs.com/IMG/case/4.gif',
              caption: '视频拍摄服务',
              title: '<p>提供多样化视频拍摄服务，企业宣传片、产品轻视频、产品图片等服务，提升企业视觉体验、捉住客户眼球</p>',
              url: '/program/solution'
            },
          ]
        },
        marketingData: {//第四屏的数据
          title: '高端海外独立站定制设计',
          caption: 'Custom',
          showdown: 'Website',
          url: '/program',//跳转地址
          textData: ['ENCOURAGE POSITIVE FEEDBACK SHARE', 'INNOVATION CULTIVATE INDUSTRY PROFESSIONAL'],
          chinese: '<p>从客户调研、网站内容梳理及策划、页面设计，开发及搜索优化都无需你绞尽脑汁。融合销售、运营、技术三位于一体的金三角服务团队，提升独立站询盘转化率。</p>',
          english: '<p>Provide Google, social media, email marketing and other omni-channel applications, as well as enterprise training solutions and other full value chain services system.</p>',
        },
        swiperOptions: {
          // autoplay: { //匀速滚动
          //     delay: 3000, //间隔时间0秒
          //     stopOnLastSlide: false,
          //     disableOnInteraction: false, //触摸后仍然执行
          // },
          scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true,
            hide: false
          },
          mousewheel: true,
          slidesPerView: 1.5,
          spaceBetween: 48,
          grabCursor: true
          // Some Swiper option/callback...
        },
        scrollbar: '#000000',
        myScrollData: {
          offset: 50, //最大溢出值
          cur: 0, //列表滑动位置
          isDown: false,
          vy: 0, //滑动的力度
          fl: 150, //弹力,值越大,到度或到顶后,可以继续拉的越远
          isInTransition: false //是否在滚动中
        },
      }
    },
    components: {
      Shade,
      Loading,
      MobilNav,
      NavBar,
      Banner,
      Introduce,
      Serve,
      OurServe,
      Marketing,
      Project,
      PhotoWall,
      Footer
    },
    created() {
      this.onread()
    },
    mounted() {
      this.getPath()
      this.onscrill()
    },
    methods: {
      onread() {
        let _this = this
        document.onreadystatechange = function () {//即在加载的过程中执行下面的代码
          if (document.readyState == "complete") {//complete加载完成
            _this.$refs.shade.hiddenShade()
            setTimeout(() => {
              _this.$refs.myLoading.lodingButton = true
              _this.getUrl()
            }, 1000)
          }
        }
      },
      getUrl() {//获取url来控制展现方式
        const that = this
        let path = this.$route.path
        if (path === '/') {
          setTimeout(() => {
            that.$refs.banner.showLogo()
            setTimeout(() => {
              that.$refs.myNav.changeNavbar()
            }, 500)
          }, 500)
        } else if (path === '/contact' || path === '/about' || path === '/case' || path === '/faq' || path === '/school') {
          setTimeout(() => {
            that.$refs.routersv.childMethods()
            setTimeout(() => {
              that.$refs.myNav.changeNavbar()
            }, 500)
          }, 500)
        } else {
          setTimeout(() => {
            that.$refs.routersv.childMethods()
            setTimeout(() => {
              that.$refs.myNav.changeNavbar()
            }, 500)
          }, 500)
        }
      },
      getPath() {//控制当前页面的子页面展现
        if (this.$route.path !== '/') {
          this.localhost = false
        } else {
          this.localhost = true
        }
      },
      changeChildMobileNav() {//控制手机导航是否展现
        this.$refs.mobilNav.changeShow()
      },
      onscrill() {//监听滚动条
        let _this = this
        window.onscroll = function () {
          //================================获取页面所有的class元素=========================================
          if (_this.ElementArry.length === 0) {
            _this.getMyARRY()
          }
          //==============================控制导航头部的文字显示=============================================
          _this.toggleLogeTilte()
          //================================控制faq页面的图钉固定组件=========================================
          if (_this.$route.path === '/faq') {
            _this.$refs.routersv.faqnavmove()
          }
          //============================执行元素位置判断=====================================================
          for (let i = 0; i < _this.ElementArry.length; i++) {
            _this.changeLogo(_this.ElementArry[i].id, _this.ElementArry[i].blooen)
          }
        }
      },


      getMyARRY() {//获取所有的有标注的class
        let whiteArr = []
        let blackArr = []
        const white = document.getElementsByClassName('white')
        for (let i = 0; i < white.length; i++) {//循环添加颜色状态
          let obj = {}
          obj.id = white[i]
          obj.blooen = false
          whiteArr.push(obj)
        }
        const black = document.getElementsByClassName('black')
        for (let i = 0; i < black.length; i++) {//循环添加颜色状态
          let obj = {}
          obj.id = black[i]
          obj.blooen = true
          blackArr.push(obj)
        }
        this.ElementArry = this.ElementArry.concat(whiteArr).concat(blackArr)
        console.log(this.ElementArry)
      },
      //====================================================判断元素位置===========================================================
      changeLogo(id, blooen) {
        // console.log(id.getBoundingClientRect())
        let _this = this
        const offset = id.getBoundingClientRect()
        const offsetTop = offset.top;
        const offsetBottom = offset.bottom;
        // 进入可视区域
        if (offsetTop <= 0 && offsetBottom >= 0) {
          // console.log('在可视区域');
          _this.$refs.myNav.changeLogo(blooen)
          // do something...
        } else if (offsetTop < 0 && offsetBottom < 0) {
          // console.log('移出可视区域,在可视区的上方');
          // _this.$refs.myNav.changeLogo(false)
          // do something...
        } else {
          // console.log('移出可视区域,在可视区的下方');
          // do something...
        }
      },

      //====================================================控制导航logo显示隐藏====================================================
      toggleLogeTilte() {
        let _this = this
        let top = document.documentElement.scrollTop || document.body.scrollTop// 获取滚动条滚动的距离
        if (top >= 200) {
          _this.$refs.myNav.changelogotext(true)
          _this.$refs.myNav.hiddenNavList(true)
        } else {
          _this.$refs.myNav.changelogotext(false)
          _this.$refs.myNav.hiddenNavList(false)
        }
      },



      // getscrollTop(id, blooen) {//判断元素是否进入视口
      //   let _this = this
      //     const offset = elem.getBoundingClientRect(); // vue中，使用this.$el获取当前组件的根元素
      //     const offsetTop = offset.top;
      //     const offsetBottom = offset.bottom;
      //     // 进入可视区域
      //     if (offsetTop <= 0 && offsetBottom >= 0) {
      //       console.log('在可视区域');
      //       _this.$refs.myNav.changeLogo(blooen)
      //       // do something...
      //     } else if (offsetTop < 0 && offsetBottom < 0) {
      //       console.log('移出可视区域,在可视区的上方');
      //       // _this.$refs.myNav.changeLogo(false)
      //       // do something...
      //     } else {
      //       console.log('移出可视区域,在可视区的下方');
      //       // do something...
      //     }
      // },
    }
  }
</script>
<style scoped>
  .dico {
    width: 20px;
    height: 20px;
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 50%;
    /* position: absolute; */
    z-index: 0;
  }

  .uccn-box {
    /*  */
    background-color: #F1F1F1;
    margin: 0 auto;
    position: absolute;
    width: 100%;
    overflow-x: hidden;
    transition: all 1s ease-out;

  }

  .uccn-box>>>.ourserve-box {
    margin-top: 0;
  }

  .ourserve-box>>>.caption {
    max-width: 370px;
    font-size: 48px;
    line-height: 67px;
    letter-spacing: 5px;
  }

  @media(max-width: 995px) {
    .ourserve-box>>>.caption {
      max-width: 100%;
      font-size: 24px;
      line-height: 139%;
      text-align: center;
    }

    .ourserve-box>>>.title {
      margin-top: 36px;
      font-size: 16px;
      line-height: 250%;
      max-width: 100%;
      text-align: center;
    }
  }
</style>


// WEBPACK FOOTER //
// src/pages/main/uccn.vue